/* Filename: assets/hinomi-warranty.js */

document.addEventListener("DOMContentLoaded", function() {
  
  const TARGET_SELECTOR = ".datePicker";

  // Core logic to initialize Flatpickr
  function initWarrantyLogic(element) {
    // Safety check: Avoid double initialization
    if (element.classList.contains("fp-enabled")) return;
    
    if (typeof flatpickr === 'undefined') {
      console.error("Hinomi Debug: Flatpickr library not loaded.");
      return;
    }

    console.log("Hinomi Debug: Target element found. Initializing...");

    const fp = flatpickr(element, {
      // static: true, // Uncomment if calendar position is off
      disable: [
        function (date) {
          return (date.getTime() > new Date().getTime());
        }
      ],
      onChange: function(selectedDates, dateStr, instance) {
        const selectedDate = selectedDates[0];
        if (!selectedDate) return;

        // Policy Dates
        const dates = {
          v1: new Date('2026-02-01')
        };

        // PDF Links
        const pdfs = {
          v1: 'https://cdn.shopify.com/s/files/1/0758/1938/4981/files/Hinomi_WarrantyPolicy_MY_20260201_Eng.pdf?v=1770110511'
        };

        const linkViewWarranty = document.querySelector('.linkViewWarranty');
        if (linkViewWarranty) {
          // if (selectedDate >= dates.v1) {
          //   linkViewWarranty.setAttribute('href', pdfs.v1);
          // }
          linkViewWarranty.setAttribute('href', pdfs.v1);
        }
      }
    });
  }

  // --- STRATEGY: Check First, Observe Later ---

  // 1. Immediate check (Fastest path)
  const existingElement = document.querySelector(TARGET_SELECTOR);
  if (existingElement) {
    initWarrantyLogic(existingElement);
    return; // Exit if successful
  }

  // 2. Fallback: MutationObserver (Safe path for PageFly)
  console.log("Hinomi Debug: Element not found immediately. Starting observer...");
  
  const observer = new MutationObserver(function(mutations, obs) {
    const element = document.querySelector(TARGET_SELECTOR);
    if (element) {
      initWarrantyLogic(element);
      obs.disconnect(); // Stop watching to save memory
      console.log("Hinomi Debug: Observer disconnected.");
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});